var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSocialTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.841,
    height: 12.849,
    viewBox: "0 0 15.841 12.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.016,14.849a9.158,9.158,0,0,0,9.24-9.24v-.44A7.153,7.153,0,0,0,53.841,3.5a7.306,7.306,0,0,1-1.848.528A3.424,3.424,0,0,0,53.4,2.264a8.072,8.072,0,0,1-2.024.792A3.143,3.143,0,0,0,49,2a3.306,3.306,0,0,0-3.256,3.256,1.716,1.716,0,0,0,.088.7,9.1,9.1,0,0,1-6.688-3.432A3.37,3.37,0,0,0,38.7,4.2a3.5,3.5,0,0,0,1.408,2.728,2.967,2.967,0,0,1-1.5-.44h0a3.216,3.216,0,0,0,2.64,3.168,2.713,2.713,0,0,1-.88.088,1.5,1.5,0,0,1-.616-.088,3.334,3.334,0,0,0,3.08,2.288,6.644,6.644,0,0,1-4.048,1.408A2.436,2.436,0,0,1,38,13.265a8.307,8.307,0,0,0,5.016,1.584",
    transform: "translate(-38 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialTw);
export default __webpack_public_path__ + "static/media/icon-social-tw.4fada7825eb9d56c512797830a192f47.svg";
export { ForwardRef as ReactComponent };